(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["block-custom-accordion-info"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('custom-accordion-info')) {
    class CustomAccordionInfo extends HTMLElement {
      #tabs = [];
      #panels = [];
      #abort = null;

      connectedCallback() {
        this.#tabs = [];
        for (const tab of this.querySelectorAll('[role="tab"]')) {
          this.#tabs.push(tab);
        }
        this.#panels = [];
        for (const panel of this.querySelectorAll('.acci__panel')) {
          this.#panels.push(panel);
        }
        if (this.#tabs.length < 2) return;

        this.#abort = new AbortController();
        const { signal } = this.#abort;

        for (const tab of this.#tabs) {
          tab.addEventListener('click', () => this.#select(tab), { signal });
          tab.addEventListener('keydown', (event) => this.#onKeydown(event, tab), { signal });
        }
      }

      disconnectedCallback() {
        this.#abort?.abort();
      }

      #select(tab) {
        for (const other of this.#tabs) {
          const active = other === tab;
          other.setAttribute('aria-selected', active ? 'true' : 'false');
          other.setAttribute('tabindex', active ? '0' : '-1');
        }
        const target = tab.getAttribute('aria-controls');
        for (const panel of this.#panels) {
          if (panel.id === target) {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', '');
          }
        }
      }

      #onKeydown(event, tab) {
        const { key } = event;
        const index = this.#tabs.indexOf(tab);
        let next = -1;

        if (key === 'ArrowRight' || key === 'ArrowDown') {
          next = (index + 1) % this.#tabs.length;
        } else if (key === 'ArrowLeft' || key === 'ArrowUp') {
          next = (index - 1 + this.#tabs.length) % this.#tabs.length;
        } else if (key === 'Home') {
          next = 0;
        } else if (key === 'End') {
          next = this.#tabs.length - 1;
        }

        if (next === -1) return;
        event.preventDefault();
        this.#tabs[next].focus();
        this.#select(this.#tabs[next]);
      }
    }

    customElements.define('custom-accordion-info', CustomAccordionInfo);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["block-custom-accordion"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('custom-accordion-group')) {
    class CustomAccordionGroup extends HTMLElement {
      #abort = null;
      #busy = new WeakSet();
      #reduced = null;

      connectedCallback() {
        this.#reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.#abort = new AbortController();
        const { signal } = this.#abort;

        for (const summary of this.querySelectorAll('summary.acc__row')) {
          summary.addEventListener('click', (event) => this.#onClick(event, summary), { signal });
        }
      }

      disconnectedCallback() {
        this.#abort?.abort();
      }

      #duration() {
        const raw = getComputedStyle(this).getPropertyValue('--acc-anim');
        const ms = Number.parseFloat(raw);
        return Number.isFinite(ms) ? ms : 250;
      }

      #skipAnimation() {
        return this.#reduced.matches || this.#duration() === 0;
      }

      #onClick(event, summary) {
        const item = summary.closest('details');
        if (!item) return;

        event.preventDefault();
        if (this.#busy.has(item)) return;

        if (item.open) {
          this.#close(item);
          return;
        }

        if (this.hasAttribute('data-exclusive')) {
          for (const other of this.querySelectorAll('details.acc__item[open]')) {
            if (other !== item && !this.#busy.has(other)) this.#close(other);
          }
        }
        this.#open(item);
      }

      #open(item) {
        const body = item.querySelector('.acc__body');
        item.open = true;
        if (!body || this.#skipAnimation()) return;

        this.#busy.add(item);
        const styles = getComputedStyle(body);
        const height = body.getBoundingClientRect().height;
        body.style.overflow = 'hidden';

        const animation = body.animate(
          [
            { blockSize: '0px', paddingBlockStart: '0px', paddingBlockEnd: '0px', opacity: 0 },
            {
              blockSize: `${height}px`,
              paddingBlockStart: styles.paddingBlockStart,
              paddingBlockEnd: styles.paddingBlockEnd,
              opacity: 1
            }
          ],
          { duration: this.#duration(), easing: 'ease' }
        );

        const cleanup = () => {
          body.style.overflow = '';
          this.#busy.delete(item);
        };
        animation.addEventListener('finish', cleanup);
        animation.addEventListener('cancel', cleanup);
      }

      #close(item) {
        const body = item.querySelector('.acc__body');
        if (!body || this.#skipAnimation()) {
          item.open = false;
          return;
        }

        this.#busy.add(item);
        const styles = getComputedStyle(body);
        body.style.overflow = 'hidden';

        const animation = body.animate(
          [
            {
              blockSize: `${body.getBoundingClientRect().height}px`,
              paddingBlockStart: styles.paddingBlockStart,
              paddingBlockEnd: styles.paddingBlockEnd,
              opacity: 1
            },
            { blockSize: '0px', paddingBlockStart: '0px', paddingBlockEnd: '0px', opacity: 0 }
          ],
          { duration: this.#duration(), easing: 'ease' }
        );

        const cleanup = () => {
          item.open = false;
          body.style.overflow = '';
          this.#busy.delete(item);
        };
        animation.addEventListener('finish', cleanup);
        animation.addEventListener('cancel', cleanup);
      }
    }

    customElements.define('custom-accordion-group', CustomAccordionGroup);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["block-flavor-dropdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('flavor-dropdown')) {
    class FlavorDropdown extends HTMLElement {
      #details = null;
      #summary = null;
      #options = [];
      #abort = null;

      connectedCallback() {
        this.#details = this.querySelector('details');
        this.#summary = this.querySelector('summary');
        if (!this.#details || !this.#summary) return;

        this.#options = [];
        for (const option of this.querySelectorAll('[data-fd-option]')) {
          this.#options.push(option);
        }

        this.#syncTrigger();

        this.#abort = new AbortController();
        const { signal } = this.#abort;

        this.addEventListener('keydown', (event) => this.#onKeydown(event), { signal });
        this.addEventListener('focusout', (event) => this.#onFocusout(event), { signal });
        document.addEventListener('click', (event) => this.#onDocumentClick(event), { signal });
        this.#details.addEventListener('toggle', () => this.#onToggle(), { signal });
      }

      disconnectedCallback() {
        this.#abort?.abort();
      }

      #onToggle() {
        const root = this.closest('.fd');
        root?.classList.toggle('fd--open', this.#details.open);
      }

      #syncTrigger() {
        if (!this.hasAttribute('data-fd-sync')) return;
        if (this.#options.length === 0) return;

        const target = this.querySelector('[data-fd-trigger-main]');
        if (!target) return;

        let chosen = this.querySelector('[data-fd-option][aria-current="true"]');
        chosen ??= this.querySelector('[data-fd-option][data-fd-preselect]');

        if (!chosen) {
          if (target.textContent.trim().length > 0) return;
          chosen = this.#options[0];
        }

        chosen.setAttribute('aria-current', 'true');
        chosen.classList.add('fd__option--selected');
        target.innerHTML = chosen.innerHTML;
      }

      #onDocumentClick(event) {
        if (!this.#details.open) return;
        if (this.contains(event.target)) return;
        this.#details.open = false;
      }

      #onFocusout(event) {
        if (!this.#details.open) return;
        if (!event.relatedTarget) return;
        if (this.contains(event.relatedTarget)) return;
        this.#details.open = false;
      }

      #onKeydown(event) {
        const { key } = event;

        if (key === 'Escape') {
          if (!this.#details.open) return;
          event.preventDefault();
          this.#details.open = false;
          this.#summary.focus();
          return;
        }

        if (key === 'ArrowDown' || key === 'ArrowUp' || key === 'Home' || key === 'End') {
          event.preventDefault();
          if (!this.#details.open) this.#details.open = true;
          this.#moveFocus(key);
        }
      }

      #moveFocus(key) {
        if (this.#options.length === 0) return;

        const activeIndex = this.#options.indexOf(document.activeElement);
        let nextIndex = 0;

        if (key === 'End') {
          nextIndex = this.#options.length - 1;
        } else if (key === 'Home') {
          nextIndex = 0;
        } else if (activeIndex === -1) {
          nextIndex = this.#selectedIndex();
        } else if (key === 'ArrowDown') {
          nextIndex = (activeIndex + 1) % this.#options.length;
        } else {
          nextIndex = (activeIndex - 1 + this.#options.length) % this.#options.length;
        }

        this.#options[nextIndex]?.focus();
      }

      #selectedIndex() {
        for (const option of this.#options) {
          if (option.getAttribute('aria-current') === 'true') {
            return this.#options.indexOf(option);
          }
        }
        return 0;
      }
    }

    customElements.define('flavor-dropdown', FlavorDropdown);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["block-option-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('option-picker')) {
    customElements.define(
      'option-picker',
      class extends HTMLElement {
        #ac;
        #busy = false;
        #syncing = false;

        connectedCallback() {
          this.#ac = new AbortController();
          const { signal } = this.#ac;

          this.#initNav();

          if (this.dataset.mode === 'link') {
            this.#buildLinks();
            this.#scrollToSelected();
            return;
          }

          if (this.dataset.mode === 'quantity') {
            this.#initQuantityMode(signal);
            return;
          }

          // Beim Laden ist nichts gewählt — der Kunde entscheidet selbst
          for (const radio of this.querySelectorAll('.opick__radio')) {
            radio.checked = false;
          }
          this.#apply(null);

          // Zweiter Klick auf dieselbe Kachel hebt die Auswahl wieder auf
          this.addEventListener(
            'click',
            (event) => {
              const label = event.target.closest('.opick__tile');
              if (!label || !this.contains(label)) return;
              const input = label.querySelector('.opick__radio');
              if (!input || input.disabled) return;

              if (input.checked && input.closest('.opick__cell')?.dataset.selected === 'true') {
                event.preventDefault();
                input.checked = false;
                this.#apply(null);
              }
            },
            { signal }
          );

          this.addEventListener(
            'change',
            (event) => {
              const input = event.target.closest('.opick__radio');
              if (input) this.#apply(input);
            },
            { signal }
          );

          this.#interceptAddToCart(false);
        }

        disconnectedCallback() {
          this.#ac?.abort();
        }

        // Produkt-Modus: Kacheln werden zu echten Links
        #buildLinks() {
          for (const cell of this.querySelectorAll('.opick__cell')) {
            const url = cell.dataset.url;
            const tile = cell.querySelector('.opick__tile');
            if (!tile || !url) continue;

            const link = document.createElement('a');
            link.className = 'opick__tile';
            const code = this.#codeOf(cell.querySelector('.opick__radio'));
            link.href = code ? '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(url) : url;
            if (cell.dataset.current === 'true') {
              link.setAttribute('aria-current', 'true');
              cell.setAttribute('data-selected', 'true');
            }

            for (const radio of tile.querySelectorAll('.opick__radio')) {
              radio.remove();
            }
            link.innerHTML = tile.innerHTML;
            tile.replaceWith(link);
          }
        }

        #productForm() {
          return (
            this.closest('form[action*="/cart/add"]') ??
            this.closest('.shopify-section')?.querySelector('form[action*="/cart/add"]') ??
            document.querySelector('form[action*="/cart/add"]')
          );
        }

        // ---------- Mengen-Modus ----------
        // Kachel → schreibt ihre Menge ins Mengenfeld des Produkts.
        // Mengenfeld (+/−, Tippen) → wählt die passende Kachel oder hebt die Auswahl auf.

        #initQuantityMode(signal) {
          this.addEventListener(
            'change',
            (event) => {
              const input = event.target.closest('.opick__radio');
              if (!input) return;
              this.#apply(input);
              this.#setQuantity(this.#tileQty(input));
            },
            { signal }
          );

          const onQuantityEvent = (event) => {
            if (this.#syncing) return;
            const field = event.target;
            if (!(field instanceof HTMLInputElement) || field.name !== 'quantity') return;
            if (field !== this.#quantityInput()) return;
            this.#syncFromQuantity();
          };
          document.addEventListener('input', onQuantityEvent, { signal, capture: true });
          document.addEventListener('change', onQuantityEvent, { signal, capture: true });

          // Plus/Minus-Buttons ändern den Wert je nach Theme ohne Event → nach dem Klick prüfen
          document.addEventListener(
            'click',
            (event) => {
              const field = this.#quantityInput();
              if (!field || event.target === field) return;
              const host =
                field.closest(
                  'quantity-selector-component, quantity-selector, quantity-input, .quantity-selector, .quantity'
                ) ?? field.parentElement;
              if (!host || !host.contains(event.target)) return;
              requestAnimationFrame(() => this.#syncFromQuantity());
              setTimeout(() => this.#syncFromQuantity(), 120);
            },
            { signal, capture: true }
          );

          // Nur Kacheln mit "Mit dem Hauptprodukt in den Warenkorb" werden mitbestellt
          this.#interceptAddToCart(true);

          if (this.dataset.preselect === 'true') {
            this.#syncFromQuantity();
          } else {
            for (const radio of this.querySelectorAll('.opick__radio')) {
              radio.checked = false;
            }
            this.#apply(null);
          }
        }

        #quantityInput() {
          const form = this.#productForm();
          if (form) {
            // form.elements enthält auch Felder, die per form="…"-Attribut außerhalb des Formulars liegen
            const found = form.elements.namedItem('quantity');
            const field = found instanceof RadioNodeList ? found[0] : found;
            if (field instanceof HTMLInputElement) return field;
          }
          const scope = this.closest('.shopify-section') ?? document;
          return scope.querySelector('input[name="quantity"]');
        }

        // Menge der Kachel: Zahl am Anfang der Beschriftung ("3 Flaschen", "3x Flasche"),
        // sonst das data-qty-Attribut der Kachel.
        #tileQty(input) {
          const label =
            input.dataset.label ??
            input.closest('.opick__cell')?.querySelector('.opick__label')?.textContent ??
            input.value ??
            '';
          const match = String(label).trim().match(/^(\d+)\s*(?:[x×]\s*|\s+)/i);
          if (match) return Number.parseInt(match[1], 10);

          const fromData = Number.parseInt(input.dataset.qty ?? '', 10);
          return fromData > 0 ? fromData : 0;
        }

        #setQuantity(qty) {
          const field = this.#quantityInput();
          if (!field || !(qty > 0)) return;

          const max = Number.parseInt(field.max, 10);
          const value = max > 0 ? Math.min(qty, max) : qty;
          if (Number.parseInt(field.value, 10) === value) return;

          this.#syncing = true;
          field.value = String(value);
          field.dispatchEvent(new Event('input', { bubbles: true }));
          field.dispatchEvent(new Event('change', { bubbles: true }));
          this.#syncing = false;
        }

        #syncFromQuantity() {
          const field = this.#quantityInput();
          const qty = field ? Number.parseInt(field.value, 10) : 0;

          let match = null;
          if (qty > 0) {
            for (const radio of this.querySelectorAll('.opick__radio')) {
              if (radio.disabled) continue;
              if (this.#tileQty(radio) === qty) {
                match = radio;
                break;
              }
            }
          }

          if (match) match.checked = true;
          this.#apply(match);
        }

        #selected() {
          return this.querySelector('.opick__radio:checked');
        }

        // onlyFlagged = true (Mengen-Modus): nur Kacheln mit data-add-with-main werden mitbestellt
        #interceptAddToCart(onlyFlagged) {
          const form = this.#productForm();
          if (!form) return;

          const button = form.querySelector('[name="add"], button[type="submit"]');
          if (!button) return;

          button.addEventListener(
            'click',
            async (event) => {
              if (this.#busy) return;

              const input = this.#selected();
              const variantId = input?.dataset.variant;
              const flagged = !onlyFlagged || input?.dataset.addWithMain === 'true';
              if (!input || !variantId || !flagged) {
                this.#scheduleDiscountRecheck();
                return;
              }

              event.preventDefault();
              event.stopImmediatePropagation();
              this.#busy = true;

              try {
                await fetch('/cart/add.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                  body: JSON.stringify({
                    items: [{ id: Number(variantId), quantity: Number(input.dataset.qty || 1) }]
                  })
                });
              } catch (error) {
                console.warn('option-picker: Zusatzprodukt konnte nicht hinzugefügt werden', error);
              }

              // Danach läuft der normale Kauf-Button des Themes weiter
              button.click();
              this.#scheduleDiscountRecheck();
              setTimeout(() => {
                this.#busy = false;
              }, 900);
            },
            { capture: true, signal: this.#ac.signal }
          );
        }

        #apply(input) {
          for (const cell of this.querySelectorAll('.opick__cell')) {
            cell.removeAttribute('data-selected');
          }

          if (input) {
            input.closest('.opick__cell')?.setAttribute('data-selected', 'true');
          } else {
            for (const radio of this.querySelectorAll('.opick__radio')) {
              radio.checked = false;
            }
          }

          const current = this.querySelector('[data-opick-current]');
          if (current) current.textContent = input ? input.dataset.label ?? input.value : '';

          this.#syncDiscount(input);
        }

        // ---------- Rabattcode ----------
        // Der Code der gewählten Kachel wird per Cart API auf den Warenkorb gelegt.
        // Bereits vorhandene Codes des Kunden bleiben erhalten, nur der eigene Code
        // wird beim Wechsel/Abwählen wieder entfernt.

        #applied = '';
        #discountBusy = null;
        #recheckTimer = 0;

        #codeOf(input) {
          return (input?.dataset.discount ?? '').trim();
        }

        #syncDiscount(input) {
          const code = this.#codeOf(input);
          this.#renderNote(code);
          if (code === this.#applied) return;
          this.#setDiscount(code);
        }

        #renderNote(code) {
          const note = this.querySelector('[data-opick-note]');
          if (!note) return;
          const text = note.querySelector('.opick__note-text');
          if (!code || !text) {
            note.hidden = true;
            return;
          }
          text.replaceChildren();
          const parts = (note.dataset.template || '[code]').split('[code]');
          parts.forEach((part, i) => {
            if (part) text.append(document.createTextNode(part));
            if (i < parts.length - 1) {
              const strong = document.createElement('span');
              strong.className = 'opick__note-code';
              strong.textContent = code;
              text.append(strong);
            }
          });
          note.hidden = false;
        }

        async #setDiscount(code) {
          const previous = this.#applied;
          this.#applied = code;
          if (this.#discountBusy) await this.#discountBusy.catch(() => {});

          const run = async () => {
            const cartRes = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
            const cart = await cartRes.json();
            const existing = (cart.discount_codes ?? []).map((d) => String(d.code ?? d).trim()).filter(Boolean);
            const lower = (v) => v.toLowerCase();

            const keep = existing.filter((c) => lower(c) !== lower(previous) && lower(c) !== lower(code));
            const next = code ? [...keep, code] : keep;

            const same = next.length === existing.length && next.every((c, i) => lower(c) === lower(existing[i]));
            if (same) return;

            await fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ discount: next.join(',') })
            });

            this.#refreshCart();
          };

          this.#discountBusy = run().catch((error) => {
            console.warn('option-picker: Rabattcode konnte nicht angewendet werden', error);
          });
          await this.#discountBusy;
          this.#discountBusy = null;
        }

        // Nach dem Kauf-Klick liegt das Produkt erst kurz später im Warenkorb — Code danach erneut prüfen
        #scheduleDiscountRecheck() {
          if (!this.#applied) return;
          clearTimeout(this.#recheckTimer);
          this.#recheckTimer = setTimeout(() => {
            const code = this.#applied;
            this.#applied = '';
            this.#setDiscount(code);
          }, 1300);
        }

        #refreshCart() {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: {} }));
          document.dispatchEvent(new CustomEvent('cart:update'));
        }

        #initNav() {
          const row = this.querySelector('[data-opick-row]');
          const prev = this.querySelector('[data-opick-prev]');
          const next = this.querySelector('[data-opick-next]');
          if (!row || !prev || !next) return;

          const { signal } = this.#ac;
          const step = () => row.clientWidth * 0.75;

          prev.addEventListener('click', () => row.scrollBy({ left: -step() }), { signal });
          next.addEventListener('click', () => row.scrollBy({ left: step() }), { signal });

          const update = () => {
            const max = row.scrollWidth - row.clientWidth;
            const overflowing = max > 4;
            prev.hidden = !overflowing || row.scrollLeft <= 4;
            next.hidden = !overflowing || row.scrollLeft >= max - 4;
          };

          row.addEventListener('scroll', update, { signal, passive: true });
          window.addEventListener('resize', update, { signal });
          update();
          requestAnimationFrame(update);
        }

        #scrollToSelected() {
          const row = this.querySelector('[data-opick-row]');
          const cell = this.querySelector(".opick__cell[data-selected='true']");
          if (!row || !cell) return;
          const offset = cell.offsetLeft - row.offsetLeft - 4;
          if (offset > 0) row.scrollLeft = offset;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["block-pills"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pills-group')) {
    customElements.define(
      'pills-group',
      class extends HTMLElement {
        #ac;
        #popover = false;

        connectedCallback() {
          this.#ac = new AbortController();
          const { signal } = this.#ac;

          // Popover-API (Top-Layer) wenn verfügbar — sonst Fallback: absolut + Shift
          this.#popover =
            typeof HTMLElement.prototype.showPopover === 'function' && CSS.supports('selector(:popover-open)');
          if (this.#popover) {
            this.classList.add('pills--popover');
            for (const tip of this.querySelectorAll('.pills__tip')) tip.setAttribute('popover', 'manual');
          }

          this.addEventListener(
            'click',
            (event) => {
              const btn = event.target.closest('button.pills__pill');
              if (!btn || !this.contains(btn)) return;
              const cell = btn.closest('.pills__cell');
              if (!cell) return;
              const wasOpen = cell.getAttribute('data-open') === 'true';
              this.#closeAll();
              if (!wasOpen) {
                cell.setAttribute('data-open', 'true');
                this.#show(cell);
              }
            },
            { signal }
          );

          document.addEventListener(
            'click',
            (event) => {
              if (!this.contains(event.target)) this.#closeAll();
            },
            { signal }
          );

          document.addEventListener(
            'keydown',
            (event) => {
              if (event.key === 'Escape') this.#closeAll();
            },
            { signal }
          );

          const cellOf = (event) => {
            const cell = event.target.closest?.('.pills__cell');
            return cell && this.contains(cell) ? cell : null;
          };

          this.addEventListener('pointerover', (event) => {
            const cell = cellOf(event);
            if (cell) this.#show(cell);
          }, { signal });

          this.addEventListener('pointerout', (event) => {
            const cell = cellOf(event);
            if (!cell || cell.contains(event.relatedTarget)) return;
            if (cell.getAttribute('data-open') !== 'true') this.#hide(cell);
          }, { signal });

          this.addEventListener('focusin', (event) => {
            const cell = cellOf(event);
            if (cell) this.#show(cell);
          }, { signal });

          this.addEventListener('focusout', (event) => {
            const cell = cellOf(event);
            if (!cell || cell.contains(event.relatedTarget)) return;
            if (cell.getAttribute('data-open') !== 'true') this.#hide(cell);
          }, { signal });

          const reposition = () => this.#repositionVisible();
          window.addEventListener('resize', reposition, { signal, passive: true });
          document.addEventListener('scroll', reposition, { signal, passive: true, capture: true });
        }

        disconnectedCallback() {
          this.#ac?.abort();
        }

        #closeAll() {
          for (const cell of this.querySelectorAll(".pills__cell[data-open='true']")) {
            cell.removeAttribute('data-open');
            this.#hide(cell);
          }
        }

        #show(cell) {
          const tip = cell.querySelector('.pills__tip');
          if (!tip) return;
          clearTimeout(tip._hideTimer);

          if (this.#popover) {
            if (!tip.matches(':popover-open')) {
              try { tip.showPopover(); } catch (error) { return; }
            }
            this.#position(cell, tip);
            requestAnimationFrame(() => requestAnimationFrame(() => tip.classList.add('is-visible')));
          } else {
            this.#shift(cell, tip);
          }
        }

        #hide(cell) {
          const tip = cell.querySelector('.pills__tip');
          if (!tip) return;
          tip.classList.remove('is-visible');
          if (!this.#popover) return;
          clearTimeout(tip._hideTimer);
          tip._hideTimer = setTimeout(() => {
            if (tip.classList.contains('is-visible') || cell.getAttribute('data-open') === 'true') return;
            if (tip.matches(':popover-open')) tip.hidePopover();
          }, 180);
        }

        #repositionVisible() {
          if (!this.#popover) return;
          for (const tip of this.querySelectorAll('.pills__tip:popover-open')) {
            const cell = tip.closest('.pills__cell');
            if (cell) this.#position(cell, tip);
          }
        }

        // Top-Layer: feste Viewport-Koordinaten, mittig über der Pill,
        // in den Viewport geklemmt; bei Platzmangel oben → unter die Pill.
        #position(cell, tip) {
          const rect = cell.getBoundingClientRect();
          const width = tip.offsetWidth;
          const height = tip.offsetHeight;
          if (!width || !rect.width) return;

          const vw = window.innerWidth || document.documentElement.clientWidth;
          const pad = 8;
          const gap = 10;
          const center = rect.left + rect.width / 2;

          let left = center - width / 2;
          left = Math.max(pad, Math.min(left, vw - pad - width));

          let top = rect.top - gap - height;
          let side = 'top';
          if (top < pad) {
            top = rect.bottom + gap;
            side = 'bottom';
          }

          tip.style.left = Math.round(left) + 'px';
          tip.style.top = Math.round(top) + 'px';
          tip.dataset.side = side;

          const arrow = Math.max(14, Math.min(center - left, width - 14));
          tip.style.setProperty('--tip-arrow', Math.round(arrow) + 'px');
        }

        // Fallback ohne Popover-API: Tooltip bleibt absolut und wird nur seitlich
        // in den nächsten Clipping-Container / Viewport geschoben.
        #shift(cell, tip) {
          const bounds = this.#clipBounds();
          const pad = 8;
          const rect = cell.getBoundingClientRect();
          const width = tip.offsetWidth;
          if (!width || !rect.width) return;

          const center = rect.left + rect.width / 2;
          const naturalLeft = center - width / 2;
          const naturalRight = center + width / 2;

          let shift = 0;
          if (naturalLeft < bounds.left + pad) shift = bounds.left + pad - naturalLeft;
          else if (naturalRight > bounds.right - pad) shift = bounds.right - pad - naturalRight;

          tip.style.setProperty('--tip-shift', Math.round(shift) + 'px');
        }

        #clipBounds() {
          let left = 0;
          let right = window.innerWidth || document.documentElement.clientWidth;
          let el = this.parentElement;
          while (el && el !== document.body) {
            const overflow = getComputedStyle(el).overflowX;
            if (overflow === 'hidden' || overflow === 'clip' || overflow === 'auto' || overflow === 'scroll') {
              const rect = el.getBoundingClientRect();
              left = Math.max(left, rect.left);
              right = Math.min(right, rect.right);
              break;
            }
            el = el.parentElement;
          }
          return { left, right };
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["block-purchase-options"] && !Shopify.designMode) return;
  try {
    class PurchaseOptions extends HTMLElement {
    #form = null;
    #data = {};
    #observer = null;
    #onFormChange = null;
    #onDocEvent = null;

    connectedCallback() {
      this.#readData();
      this.#form = this.#findForm();
      this.#bindChoices();
      this.#bindIntervals();
      this.#bindSteppers();
      this.#watchVariant();
      this.sync();
    }

    disconnectedCallback() {
      this.#observer?.disconnect();
      if (this.#form && this.#onFormChange) {
        this.#form.removeEventListener('change', this.#onFormChange);
      }
      if (this.#onDocEvent) {
        for (const name of ['variant:update', 'variant:change', 'variantChange', 'product:variant-change']) {
          document.removeEventListener(name, this.#onDocEvent);
        }
      }
    }

    #readData() {
      const el = this.querySelector('[data-po-data]');
      if (!el) return;
      try {
        this.#data = JSON.parse(el.textContent);
      } catch (error) {
        this.#data = {};
      }
    }

    #findForm() {
      const own = this.closest('form[action*="/cart/add"]');
      if (own) return own;

      const section = this.closest('.shopify-section, [id^="shopify-section"]');
      const scoped = section?.querySelector('form[action*="/cart/add"]');
      if (scoped) return scoped;

      return document.querySelector('form[action*="/cart/add"]');
    }

    /* Entfernt selling_plan-Felder, die nicht von diesem Block stammen -
       z. B. aus einem noch aktiven App-Widget. Zwei Felder gleichen Namens
       wuerden sich im FormData gegenseitig ueberschreiben. */
    #removeForeignPlanInputs() {
      if (!this.#form || this.dataset.cleanPlans !== 'true') return;
      for (const field of this.#form.querySelectorAll('[name="selling_plan"]')) {
        if (!field.hasAttribute('data-po-selling-plan')) field.remove();
      }
    }

    #applySellingPlan(planId) {
      if (!this.#form) return;
      this.#removeForeignPlanInputs();
      const existing = this.#form.querySelector('input[data-po-selling-plan]');

      if (!planId) {
        existing?.remove();
        return;
      }

      const input = existing || document.createElement('input');
      if (!existing) {
        input.type = 'hidden';
        input.name = 'selling_plan';
        input.setAttribute('data-po-selling-plan', '');
        this.#form.appendChild(input);
      }
      input.value = planId;
    }

    #bindChoices() {
      for (const radio of this.querySelectorAll('[data-po-radio]')) {
        radio.addEventListener('change', () => this.sync());
      }
    }

    #bindIntervals() {
      for (const select of this.querySelectorAll('[data-po-interval]')) {
        select.addEventListener('change', (event) => {
          const card = event.target.closest('[data-po-card]');
          if (!card) return;

          card.dataset.poPlan = event.target.value;

          const radio = card.querySelector('[data-po-radio]');
          if (radio) {
            radio.value = event.target.value;
            radio.checked = true;
          }

          this.sync();
        });
      }
    }

    #quantityInput() {
      if (!this.#form) return null;
      const existing = this.#form.querySelector('[name="quantity"]');
      if (existing) return existing;

      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'quantity';
      input.value = '1';
      this.#form.appendChild(input);
      return input;
    }

    #bindSteppers() {
      const min = Number(this.dataset.qtyMin) || 1;
      const max = Number(this.dataset.qtyMax) || 99;

      for (const stepper of this.querySelectorAll('[data-po-stepper]')) {
        for (const btn of stepper.querySelectorAll('[data-po-step]')) {
          btn.addEventListener('click', () => {
            const source = this.#quantityInput();
            const current = Number(source?.value) || min;
            const next = Math.min(max, Math.max(min, current + Number(btn.dataset.poStep)));

            if (source) {
              source.value = String(next);
              source.dispatchEvent(new Event('change', { bubbles: true }));
            }
            this.#renderQuantity(next, min, max);
            this.#renderTiers(next);
          });
        }
      }
    }

    #renderQuantity(value, min, max) {
      for (const stepper of this.querySelectorAll('[data-po-stepper]')) {
        const valueEl = stepper.querySelector('[data-po-qty-value]');
        if (valueEl) valueEl.textContent = String(value);

        for (const btn of stepper.querySelectorAll('[data-po-step]')) {
          const step = Number(btn.dataset.poStep);
          btn.disabled = step < 0 ? value <= min : value >= max;
        }
      }
    }

    /* Hebt die hoechste Staffel hervor, deren Mindestmenge erreicht ist.
       Rein visuell - der echte Rabatt kommt aus Seal bzw. Shopify. */
    #renderTiers(quantity) {
      if (this.dataset.tierHighlight !== 'true') return;

      const tiers = [...this.querySelectorAll('[data-po-tier]')];
      if (tiers.length === 0) return;

      let bestQty = -1;
      for (const tier of tiers) {
        const need = Number(tier.dataset.poTierQty) || 0;
        if (need <= quantity && need > bestQty) bestQty = need;
      }

      for (const tier of tiers) {
        const need = Number(tier.dataset.poTierQty) || 0;
        const on = bestQty >= 0 && need === bestQty;
        tier.classList.toggle('purchase-tier--active', on && tier.classList.contains('purchase-tier'));
        tier.classList.toggle('purchase-tiers__item--active', on && tier.classList.contains('purchase-tiers__item'));
      }
    }

    #variantInput() {
      return this.#form?.querySelector('[name="id"]') || null;
    }

    #watchVariant() {
      this.#onFormChange = () => window.requestAnimationFrame(() => this.sync());
      this.#form?.addEventListener('change', this.#onFormChange);

      this.#onDocEvent = () => window.requestAnimationFrame(() => this.sync());
      for (const name of ['variant:update', 'variant:change', 'variantChange', 'product:variant-change']) {
        document.addEventListener(name, this.#onDocEvent);
      }

      const input = this.#variantInput();
      if (!input) return;
      this.#observer = new MutationObserver(() => this.sync());
      this.#observer.observe(input, { attributes: true, attributeFilter: ['value'] });
    }

    #currentVariantId() {
      const value = this.#variantInput()?.value;
      if (value) return String(value);
      return String(this.dataset.defaultVariant || '');
    }

    sync() {
      const table = this.#data[this.#currentVariantId()] || {};
      let activePlan = '';

      for (const card of this.querySelectorAll('[data-po-card]')) {
        const radio = card.querySelector('[data-po-radio]');
        const isSelected = Boolean(radio && radio.checked);
        const planKey = card.dataset.poPlan ? card.dataset.poPlan : 'onetime';

        card.classList.toggle('purchase-card--selected', isSelected);

        const panel = card.querySelector('[data-po-panel]');
        if (panel) panel.inert = !isSelected;

        if (isSelected) activePlan = card.dataset.poPlan || '';

        const badgeEl = card.querySelector('[data-po-badge]');
        if (badgeEl) {
          const saving = Number(table[planKey]?.saving) || 0;
          const prefix = badgeEl.dataset.poBadgePrefix || '';
          badgeEl.textContent = saving > 0 ? `${prefix}${saving}%` : '';
        }
      }

      this.#applySellingPlan(activePlan);

      const min = Number(this.dataset.qtyMin) || 1;
      const max = Number(this.dataset.qtyMax) || 99;
      const qty = Number(this.#quantityInput()?.value) || min;
      this.#renderQuantity(qty, min, max);
      this.#renderTiers(qty);
    }
  }

  if (!customElements.get('purchase-options')) {
    customElements.define('purchase-options', PurchaseOptions);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["tb-product-videos"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tb-product-videos')) customElements.define('tb-product-videos', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const {signal} = this.controller;
      const dialog = this.querySelector('dialog');
      const player = this.querySelector('[data-tb-video-player]');
      const stop = () => player?.querySelectorAll('video').forEach(video => { video.pause(); video.currentTime = 0; });
      this.addEventListener('click', event => {
        if (!(event.target instanceof Element)) return;
        const close = event.target.closest('[data-tb-video-close]');
        if (close || event.target === dialog) { dialog.close(); return; }
        const button = event.target.closest('[data-tb-video-open]');
        if (!button || !dialog || !player) return;
        this.opener = button;
        const key = button.dataset.tbVideoOpen;
        stop();
        player.querySelectorAll('video').forEach(video => video.hidden = true);
        const template = player.querySelector('template[data-tb-video="' + key + '"]');
        if (template) {
          const fragment = template.content.cloneNode(true);
          const video = fragment.querySelector('video');
          video.dataset.tbVideo = key;
          template.replaceWith(fragment);
          // Safari 15 can leave a template-cloned video at HAVE_NOTHING
          // until load() explicitly starts source selection after insertion.
          video.load();
        }
        const video = player.querySelector('video[data-tb-video="' + key + '"]');
        if (!video) return;
        video.hidden = false;
        dialog.showModal();
        video.play().catch(() => {});
      }, {signal});
      dialog?.addEventListener('close', () => {
        stop();
        this.opener?.focus({ preventScroll: true });
      }, {signal});
      document.addEventListener('visibilitychange', () => { if (document.hidden) stop(); }, {signal});
    }
    disconnectedCallback() {
      this.querySelectorAll('video').forEach(video => video.pause());
      this.controller?.abort();
      this.controller = null;
    }
  });
  } catch(e) { console.error(e); }
})();

})();
